import { postApiV1ReferralSourceClickTrackings } from '@/open-api/referral-source-click-trackings/referral-source-click-trackings';

/**
 * Records a visit from a referral source link. Tracking is best effort: an
 * unknown code (404) is not the visitor's problem, so failures are swallowed.
 */
export const trackReferralSourceClick = async (code: string): Promise<void> => {
  try {
    await postApiV1ReferralSourceClickTrackings({ code });
  } catch {
    // Ignored: see above.
  }
};
